import APPCONFIG from '../../../constants/Config';
import {
  REFRESH_LIST,
  REFRESH_LIST_REINIT,
  UPDATE_LIST_LAST_PARAMS,
} from '../../../constants/ActionTypes';

const initialSettings = APPCONFIG.list;
const list = (state = initialSettings, action) => {
  switch (action.type) {
    // REFRESH
    case REFRESH_LIST:
      return {
        ...state,
        needRefresh: true,
      };
    case REFRESH_LIST_REINIT:
      return {
        ...state,
        needRefresh: false,
      };
    // UPDATE LAST PARAMS
    case UPDATE_LIST_LAST_PARAMS:
      if (action.reinit) {
        return {
          ...state,
          lastParams: {
            ...state.lastParams,
            ...{
              [action.target]: {
                pagination: null,
                sort: null,
                filters: null,
              },
            },
          },
        };
      }
      return {
        ...state,
        lastParams: {
          ...state.lastParams,
          ...{
            [action.target]: {
              pagination: action.pagination || (state.lastParams[action.target] && state.lastParams[action.target].pagination),
              sort: action.sort || (state.lastParams[action.target] && state.lastParams[action.target].sort),
              filters: action.filters || (state.lastParams[action.target] && state.lastParams[action.target].filters),
            },
          },
        },
      };
    default:
      return state;
  }
};

export default list;



// WEBPACK FOOTER //
// ./reducers/app/list/list.js